import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ExportRenderQueueMutationVariables = Types.Exact<{
  jobId: Types.Scalars['ID']['input'];
  skipDone?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type ExportRenderQueueMutation = { __typename?: 'Mutation', exportRenderQueue?: { __typename?: 'ExportRenderPayload', jobId: string, items: Array<{ __typename?: 'ExportRenderItem', compositionId: string, compositionName: string, outputPath: string, index: number }> } | null };


export const ExportRenderQueue = /*#__PURE__*/ gql`
    mutation ExportRenderQueue($jobId: ID!, $skipDone: Boolean) {
  exportRenderQueue(jobId: $jobId, skipDone: $skipDone) {
    jobId
    items {
      compositionId
      compositionName
      outputPath
      index
    }
  }
}
    ` as unknown as DocumentNode<ExportRenderQueueMutation, ExportRenderQueueMutationVariables>;

          

          export const useExportRenderQueueMutation = (options?:MutationHookOptions<ExportRenderQueueMutation, ExportRenderQueueMutationVariables>) => useMutation(ExportRenderQueue, options);
          

          export type ExportRenderQueueMutationOptions = MutationHookOptions<ExportRenderQueueMutation, ExportRenderQueueMutationVariables>;

          

          export type ExportRenderQueueMutationResult = ReturnType<typeof useExportRenderQueueMutation>[1];

          
